import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { NuqsAdapter } from "nuqs/adapters/react-router";

import { router } from "./routes/router";
import { queryClient } from "./queries/client";
import { ThemeModeProvider } from "./theme/ThemeModeProvider";
import { AuthInitializer } from "./features/auth/AuthInitializer";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <NuqsAdapter>
            <AuthInitializer>
              <RouterProvider router={router} />
            </AuthInitializer>
          </NuqsAdapter>
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </LocalizationProvider>
    </ThemeModeProvider>
  </React.StrictMode>,
);
